
//Here's the api connector to communicate with the wordpress
//https://localhost/cms-service/index.php/wp-json/v1/wellness-center

import { get } from '@kit/utils/APIV1.js'

export const page = async() => {
  return get(`wellness-center`)
}